export function getRecordId(record) {
    return record?.id ?? record?.pk;
}

export function isMsbForDeviceType(msb, selectedType) {
    const selectedTypeId = Number(selectedType);
    if (!selectedTypeId || selectedTypeId === -1) {
        return false;
    }

    if (!msb?.deviceType) {
        return true;
    }

    return Number(getRecordId(msb.deviceType)) === selectedTypeId;
}
